var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('AppNavbar'),_c('div',{class:[
      ( _obj = {}, _obj[_vm.$style.container] = !_vm.isPadless, _obj[_vm.$style.padLessContainer] = _vm.isPadless, _obj )
    ]},[_c('vue-headful',{attrs:{"title":_vm.title,"description":_vm.description}}),_vm._t("default")],2),(!_vm.disableFooter)?_c('AppFooter'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }